// ===========================================================================
// Module I — New Member Onboarding · Fake data
//
// No existe dump JSON para onboarding (la fuente real será
// SPSOURCE.dbo.TAB_ACA_NEW_MEMBER vía outreach.TAB_ONBOARDING). Este archivo
// genera ~15 nuevos miembros realistas por location de forma DETERMINÍSTICA
// (seed = locationKey + índice), para que la UI sea estable entre renders.
// SIMULADO hasta que exista el endpoint backend.
// ===========================================================================

const FIRST_NAMES = [
  "MARIA", "JOSE", "CARMEN", "ROBERT", "LINDA", "PEDRO", "ANA", "JAMES",
  "ROSA", "CARLOS", "PATRICIA", "JUAN", "MICHELLE", "LUIS", "BARBARA",
  "JORGE", "SUSAN", "MIGUEL", "NANCY", "RAFAEL",
];

const LAST_NAMES = [
  "RODRIGUEZ", "SMITH", "GARCIA", "JOHNSON", "MARTINEZ", "WILLIAMS",
  "HERNANDEZ", "BROWN", "LOPEZ", "JONES", "GONZALEZ", "MILLER", "PEREZ",
  "DAVIS", "SANCHEZ", "WILSON", "RAMIREZ", "TAYLOR", "TORRES", "MOORE",
];

const PCPS = [
  "SIDDIKI, AWAIS MD",
  "SMITH, REYNALDO PEZZOTTI MD",
  "GASPARD, RICARDO EMMANUEL MD",
  "MORALES, CRISTINA MD",
  "NGUYEN, THANH DO",
];

const PLANS = ["ACA Bronze", "ACA Silver", "ACA Gold", "Medicare Advantage"];

/** Hash determinístico simple de un string (estable entre sesiones). */
function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h * 31 + str.charCodeAt(i)) >>> 0; // eslint-disable-line no-bitwise
  }
  return h;
}

/**
 * Genera la lista determinística de nuevos miembros de una location (~15).
 * El progreso del checklist se reparte por seed para cubrir todas las etapas.
 *
 * @param {string} locationKey - Key de la location (e.g. "fort_myers")
 * @returns {Object[]} Nuevos miembros con checklist de onboarding
 */
export function buildNewMembers(locationKey) {
  const base = hashString(locationKey);
  const count = 13 + (base % 4); // 13-16 miembros por location

  return Array.from({ length: count }, (_, i) => {
    const seed = base + i * 7919; // primo para dispersar
    const cipId = 10000000000 + ((seed * 104729) % 89999999999);
    const first = FIRST_NAMES[seed % FIRST_NAMES.length];
    const last = LAST_NAMES[(seed >> 3) % LAST_NAMES.length]; // eslint-disable-line no-bitwise

    // Días desde el enrollment: 3-88 (ventana de 90 días para el AWV)
    const daysSinceEnrollment = 3 + (seed % 86);
    const enrollmentDate = new Date();
    enrollmentDate.setDate(enrollmentDate.getDate() - daysSinceEnrollment);

    // Progreso del checklist: cuanto más antiguo el enrollment, más avanzado.
    // stageRoll mezcla seed + antigüedad para cubrir todas las etapas.
    const stageRoll = (seed + daysSinceEnrollment) % 10;
    const stepsDone =
      daysSinceEnrollment < 10
        ? stageRoll % 2 // recién enrolados: 0-1 pasos
        : stageRoll <= 1
        ? 0
        : stageRoll <= 3
        ? 1
        : stageRoll <= 5
        ? 2
        : stageRoll <= 7
        ? 3
        : 4;

    const hasPhone = seed % 7 !== 0; // ~86% con teléfono
    const hasEmail = seed % 3 !== 0; // ~66% con email

    return {
      cipId,
      name: `${last}, ${first}`,
      age: 22 + (seed % 55),
      gender: seed % 2 === 0 ? "F" : "M",
      plan: PLANS[seed % PLANS.length],
      pcpName: PCPS[seed % PCPS.length],
      enrollmentDate: enrollmentDate.toISOString().slice(0, 10),
      daysSinceEnrollment,
      phone: hasPhone
        ? `(239) ${String(200 + (seed % 700)).padStart(3, "0")}-${String(seed % 10000).padStart(4, "0")}`
        : null,
      email: hasEmail ? `${first.toLowerCase()}.${last.toLowerCase()}@example.com` : null,
      checklist: {
        welcomeCall: stepsDone >= 1,
        recordsRequest: stepsDone >= 2,
        firstAppointment: stepsDone >= 3,
        hraCompleted: stepsDone >= 4,
      },
    };
  });
}
